import { render, staticRenderFns } from "./lacrimalirrigation.vue?vue&type=template&id=669172ee&scoped=true&"
import script from "./lacrimalirrigation.vue?vue&type=script&lang=js&"
export * from "./lacrimalirrigation.vue?vue&type=script&lang=js&"
import style0 from "./lacrimalirrigation.vue?vue&type=style&index=0&id=669172ee&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "669172ee",
  null
  
)

export default component.exports